import React from 'react';

import Spaced from 'components/Spaced';
import styles from './Store.module.css';

const Store: React.FCWithChildren = props => {
  const { children } = props;

  return (
    <Spaced className={styles.root} spacing={3}>
      {children}
    </Spaced>
  );
};

export default Store;
